import React from 'react';
import { useTranslate } from 'react-admin';
import cx from 'classnames';

import { makeStyles } from '@material-ui/core/styles';
import TrueIcon from '@material-ui/icons/Done';
import { Longdash, hasTranslation } from '~/utils';
import Skeleton from '@material-ui/lab/Skeleton';
import SvgIcon from '@material-ui/core/SvgIcon';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  labeledField: {
    display: 'flex',
    flexDirection: 'column',
    '& label': {
      marginBottom: 2,
      fontSize: 10,
    },
  },
  content: {
    height: 19,
    '& > svg': {
      height: 19,
    },
  },
  icon: {
    marginRight: theme.spacing(1),
  },
}));

export interface Props {
  label?: string;
  value: boolean;
  nullOnFalse?: boolean;
  icon?: React.ReactNode;
  loading?: boolean;
  className?: string;
  [x: string]: any;
}

const BooleanField = ({
  label,
  value,
  nullOnFalse,
  addLabel = true,
  icon,
  loading,
  className,
}: Props) => {
  const translate = useTranslate();
  const classes = useStyles();

  return (
    <div className={cx(classes.root, className)}>
      {icon &&
        (loading ? (
          <Skeleton className={classes.icon} variant='circle' width={20} height={20} />
        ) : (
          <SvgIcon className={classes.icon}>{icon}</SvgIcon>
        ))}
      <div className={classes.labeledField}>
        {addLabel && label && <label>{hasTranslation(label) ? translate(label) : label}</label>}
        <div className={classes.content}>
          {value === true ? <TrueIcon /> : nullOnFalse ? null : Longdash}
        </div>
      </div>
    </div>
  );
};

export default BooleanField;
